import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

export default [
  {
    imgSrc:
      'https://www.nerdwallet.com/assets/blog/wp-content/uploads/2015/09/GettyImages-1217584509-2119x1414.jpg',
    imgAlt: 'Cellphone screen showing financial information',
    title: "How to Decide It's Time to Buy a home",
    subtitle:
      'If you have a steady income, a good credit score, manageable debt and some money in savings and you want to put down some roots, you may be ready to buy a house.',
    description:
      'It can be hard to know when to go from renter to owner. Here are some key factors to consider.',
    impressionTrackingId: 'hac-related-articles-decide',
    link: '/blog/mortgages/how-to-decide-whether-to-buy-a-home/?trk_source=mortgages_hac_mustread&trk_content=blog_mortgages/timetobuy+pos_topleft&trk_destination=how-to-decide-whether-to-buy-a-home&trk_origin=calculate-affordability&trk_app=tool',
  },
  {
    imgSrc: iconUri('Scale'),
    imgAlt: 'Old weighing scale',
    title: 'How Much House Can You Really Afford?',
    description:
      'Before you buy the biggest house you can afford, consider the benefits of a smaller, more manageable monthly mortgage payment.',
    impressionTrackingId: 'hac-related-articles-afford',
    link: '/blog/mortgages/house-afford/?trk_source=mortgages_hac_mustread&trk_content=blog_reallyafford+pos_topright&trk_destination=house-afford&trk_origin=calculate-affordability&trk_app=tool',
  },
  {
    imgSrc: iconUri('Cash_back_3'),
    imgAlt: 'Cash Back',
    title: 'What It Costs to Buy a Home',
    description:
      "Get the bottom line on what you'll have to pay to buy a house, from one-time, move-in fees to ongoing monthly expenses.",
    impressionTrackingId: 'hac-related-articles-costs',
    link: '/blog/mortgages/costs-buy-home/?trk_source=mortgages_hac_mustread&trk_content=blog_coststobuy+pos_bottomleft&trk_destination=costs-buy-home&trk_origin=calculate-affordability&trk_app=tool',
  },
  {
    imgSrc: iconUri('House_4'),
    imgAlt: 'House',
    title: 'What to Expect From the Homebuying Process',
    description:
      "Buying a home can seem complicated and scary. Don't worry, it's not that bad. Here's a breakdown of what to expect.",
    impressionTrackingId: 'hac-related-articles-process',
    link: '/blog/mortgages/homebuying-process-expectations/?trk_source=mortgages_hac_mustread&trk_content=blog_homebuyingprocess+pos_bottomright&trk_destination=homebuying-process-expectations&trk_origin=calculate-affordability&trk_app=tool',
  },
];
